/*
 * Maps the network's webpage settings (settingsData from getWebPageSettings)
 * to CSS custom properties scoped on the new video detail page root.
 * Colour pairs follow the classic page: primary = buttons, secondary = page panel, tertiary = list rows.
 */

export const VIDEO_DETAIL_THEME_FIELDS: Record<string, string> = {
  '--vd-accent': 'bg_primary_color',
  '--vd-on-accent': 'font_primary_color',
  '--vd-bg': 'bg_secondary_color',
  '--vd-text': 'font_secondary_color',
  '--vd-surface': 'bg_tertiary_color',
  '--vd-on-surface': 'font_tertiary_color',
  '--vd-menu-bg': 'form_bg_color',
  '--vd-menu-text': 'form_font_secondary_color',
  '--vd-font': 'font_family',
  '--vd-fs-title': 'fs_main_title',
  '--vd-fs-sub': 'fs_sub_title',
  '--vd-fs-body': 'fs_sentence',
};

const HERO_TINT_ALPHA = 0.35;
const ROUND_RADIUS = '12px';
const SQUARE_RADIUS = '0px';

/** '#33297A' or '#abc' → 'rgba(r,g,b,a)'. Any other format is returned unchanged (no tint). */
export function withAlpha(color: string, alpha: number): string | null {
  const hex = String(color || '').trim().replace('#', '');
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;
  const n = parseInt(full, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

/** Every setting videoDetailThemeVars reads, so the result can be cached safely. */
export function videoDetailThemeKey(settings: any): string {
  const s = settings || {};
  return Object.values(VIDEO_DETAIL_THEME_FIELDS).map(field => s[field]).concat(s.card_shape).join('|');
}

export function videoDetailThemeVars(settings: any): Record<string, string> {
  const vars: Record<string, string> = {};
  const source = settings || {};
  Object.keys(VIDEO_DETAIL_THEME_FIELDS).forEach(cssVar => {
    const value = source[VIDEO_DETAIL_THEME_FIELDS[cssVar]];
    if (value !== undefined && value !== null && value !== '') {
      vars[cssVar] = String(value);
    }
  });
  const tint = withAlpha(source.bg_primary_color, HERO_TINT_ALPHA);
  if (tint) vars['--vd-hero-tint'] = tint;
  vars['--vd-radius'] = source.card_shape && source.card_shape !== 'round' ? SQUARE_RADIUS : ROUND_RADIUS;
  return vars;
}
